import { render, staticRenderFns } from "./LomTrainingDate.vue?vue&type=template&id=2f4191a8&scoped=true"
import script from "./LomTrainingDate.vue?vue&type=script&lang=js"
export * from "./LomTrainingDate.vue?vue&type=script&lang=js"
import style0 from "./LomTrainingDate.vue?vue&type=style&index=0&id=2f4191a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4191a8",
  null
  
)

export default component.exports